module.exports = {"contact":{"SUPPORT_CENTER_TITLE":"Support Center","WEBMAIL_ACCESS_TITLE":"Webmail Access","ADVERTISERS_TITLE":"Advertisers","ABUSE_TITLE":"Abuse","FACEBOOK_TITLE":"Facebook","X_TITLE":"X"}}


//////////////////
// WEBPACK FOOTER
// ./lib/brave-contact/i18n/en.json
// module id = Fc63
// module chunks = 0